import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getUserDetailsFromReducer } from "Store/reducers/Auth/AuthSlice";
import { socialMediaLinksData } from "Utility/Contants/SocialMediaData";

const ShowSocialMediaIcons = () => {
  const userDetails = useSelector(getUserDetailsFromReducer);
  const [links, setLinks] = useState({}); // State for links

  // Update links userDetails changes
  useEffect(() => {
    setLinks({
      facebook: userDetails?.facebook,
      instagram: userDetails?.instagram,
      x: userDetails?.x,
      linkedin: userDetails?.linkedin,
      youtube: userDetails?.youtube,
      pintrest: userDetails?.pintrest,
      whatsapp: userDetails?.whatsapp,
      googlemap: userDetails?.googlemap,
      calendly: userDetails?.calendly,
      tiktok: userDetails?.tiktok,
      reddit: userDetails?.reddit,
      buymeacoffe: userDetails?.buymeacoffe,
    });
  }, [userDetails]);

  // const areAllLinksEmpty = Object.values(links).every((link) => !link);
  // const areAllLinksFilled = Object.values(links).every((link) => link);

  return (
    <div className="w-full mb-4 sm:mb-6">
      <div className="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-8 lg:grid-cols-6 gap-2 sm:gap-3">
        {socialMediaLinksData.map((item, index) =>
          links[item.name] ? (
            <div key={index}>
              <a
                href={links[item.name]}
                target="_blank"
                rel="noreferrer"
                className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-white shadow-md group transition-all duration-300 animate-fade-slide-in hover:shadow-lg hover:scale-105"
              >
                <img
                  src={item?.icon}
                  alt={`social media icon for ${item?.icon}`}
                  className="h-4 w-4 sm:h-5 sm:w-5 md:h-6 md:w-6"
                />
              </a>
            </div>
          ) : null
        )}
      </div>
    </div>
  );
};

export default ShowSocialMediaIcons;
